import { foodsActions as actions } from '@/entities/foods';
import { useAppDispatch, useAppSelector } from '@/shared/model';
import { Select } from '@/shared/ui/Select/Select';

export const SelectAge = () => {
  const dispatch = useAppDispatch();
  const { age } = useAppSelector((state) => state.foods.form.main);

  const { ages } = useAppSelector((state) => state.foods);
  const selected =
    ages.find((item) => String(item.id) === String(age?.id)) ?? age;
  return (
    <Select
      name={'age'}
      data-testid={'select-age'}
      id={'age'}
      selected={selected}
      required
      values={ages}
      handleSelect={(value) =>
        dispatch(
          actions.changeRecipesForm({
            key: 'age',
            value: value,
          })
        )
      }
      label={'Возраст'}
      placeholderClassName={selected?.title ? '' : 'text-gray-300'}
      containerClassName='w-[428px]'
      placeholder={selected?.title || 'Выберите'}
    />
  );
};
